<template>
    <div>
        <Header/>
        <Title/>
        <div class="recordCard">
            <a-tabs default-active-key="1">
                <a-tab-pane key="1" tab="过关">
                    Content of Tab Pane 1
                </a-tab-pane>
                <a-tab-pane key="2" tab="作品">
                    Content of Tab Pane 2
                </a-tab-pane>
                <a-tab-pane key="3" tab="发言">
                    Content of Tab Pane 3
                </a-tab-pane>
            </a-tabs>
        </div>
    </div>
</template>

<script>
import Header from '@/components/header'
import Title from '../components/Title.vue'

export default {
    components: {
        Header, Title
    }
}
</script>

<style lang="less">
body {
    background-color: #f6f6f6 !important;
}
.recordCard {
    padding: 10px;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 3px rgba(18,18,18,.1);
    box-shadow: 0 1px 3px rgba(18,18,18,.1);
    margin: 10px;
}
</style>